module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_audio_x32-2108c.png";